import { render, staticRenderFns } from "./Gerch.vue?vue&type=template&id=1066e9b2&scoped=true&"
import script from "./Gerch.vue?vue&type=script&lang=js&"
export * from "./Gerch.vue?vue&type=script&lang=js&"
import style0 from "./Gerch.vue?vue&type=style&index=0&id=1066e9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066e9b2",
  null
  
)

export default component.exports